module.exports = __webpack_public_path__ + "img/gui_00_landing_2_bg.159430a8.jpg";